import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AuthContainer, Button } from '@/components';

interface PasswordForgotSuccessProps {}

const PasswordForgotSuccess: FC<PasswordForgotSuccessProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const clickHandler = () => {
    navigate('/signin');
  };

  return (
    <AuthContainer
      title={t('translation.password_forgot_success_title')}
      note={t('translation.password_forgot_success_note')}
      buttons={
        <div>
          <Button size="m" minWidth={240} corner="rect" onClick={clickHandler}>
            {t('translation.ok')}
          </Button>
        </div>
      }
    />
  );
};

export default PasswordForgotSuccess;
